<template>
    <div>
        <div class="flex p-20 justify-center">
            <icon icon="lock" size="8x" class="opacity-25" spin></icon>
        </div>

        <modal ref="modal" :disable-close="true" :content-class="'md:p-5 md:w-3/4 lg:w-3/4 md:mt-10 md:mb-20'">
            <div v-if="scenario === 'monitorar_app_lock'" class="h-full bg-purple-900 overflow-y-scroll flex flex-col items-stretch">
                <div class="p-10 text-4xl">
                    Antes de prosseguir, veja o vídeo abaixo
                    para entender como essa ferramenta funciona
                </div>

                <div class="flex-1">
                    <div class="video py-10">
                        <div style="padding:56.25% 0 0 0;position:relative;"><iframe @error="scenarios[scenario].watched=true" frameborder="0" allowfullscreen :src="scenarios[scenario].video" style="position:absolute;top:0;left:0;width:100%;height:100%;" referrerpolicy="origin"></iframe></div>
                    </div>
                </div>

                <div class="p-5 pt-10">
                    <button class="btn btn-blue"
                            :class="{'opacity-50': !scenarios[scenario].watched}"
                            :disabled="loading"
                            @click="scenarios[scenario].nextPage()">Prosseguir</button>
                </div>
            </div>


            <div v-if="scenario === 'zapin_app'" class="h-full bg-purple-900 overflow-y-scroll flex flex-col items-stretch">
                <div class="p-10 text-4xl">
                    Veja o vídeo abaixo
                    para entender como nossa ferramenta funciona
                </div>

                <div class="flex-1">
                    <div class="video py-10">
                        <div style="padding:56.25% 0 0 0;position:relative;"><iframe frameborder="0" allowfullscreen :src="scenarios[scenario].video" style="position:absolute;top:0;left:0;width:100%;height:100%;" referrerpolicy="origin"></iframe></div>
                    </div>
                </div>

                <div class="p-5 pt-10">
                    <button class="btn btn-blue"
                            :disabled="loading"
                            @click.prevent="scenarios[scenario].nextPage()">Voltar</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<style scoped>

</style>

<script>
    import {Auth} from "@/services/Api";

    export default {
        inject: ['alert'],

        mounted() {
            this.setScenario(
                this.$route.query?.sc
            )

            this.$refs.modal.open();
        },

        data() {
            return {
                loading: false,
                scenario: 'zapin_app',
                scenarios: {
                    zapin_app: {
                        video: 'https://scripts.converteai.net/5cb185e3-e4c5-418f-9cc4-eb3afdc208eb/players/65721aad5c21430008599731/embed.html',
                        nextPage: () => {
                            this.goTo('/')
                        }
                    },

                    monitorar_app_lock: {
                        video: 'https://scripts.converteai.net/5cb185e3-e4c5-418f-9cc4-eb3afdc208eb/players/657216fe221762000ae706f2/embed.html',

                        nextPage: async () => {
                            if(!this.scenarios[this.scenario]?.watched) {
                                return this.alert.info('Assista o vídeo até o final para prosseguir');
                            }

                            await this.goTo('/')
                        },

                        prepare: () => {
                            window.addEventListener('message', (e) => {
                                if(e.data?.e === 'videoWatched') {
                                    this.scenarios[this.scenario].watched = true;

                                    this.registerEvent('watched')
                                }
                            });
                        }
                    }
                }
            }
        },

        methods: {
            setScenario(scenario) {
                if(scenario in this.scenarios) {
                    this.scenario = scenario;
                    this.scenarios[scenario]?.prepare();
                }

                this.registerEvent('in')
            },

            async goTo(path) {
                await this.registerGoOut();

                this.$router.push(path);
            },

            async registerEvent(name) {
                if(Auth.currentUser()) {
                    return await Auth.currentUser()
                        .account()
                        .registerEvent('video.demonstration.' + name, {
                            scenario: this.scenario,
                            video: this.scenarios[this.scenario].video
                        })
                }

                return Promise.resolve();
            },

            async registerGoOut() {
                this.loading = true;

                return this
                    .registerEvent('out')
                    .finally(() => this.loading = false)
            }
        }

    }
</script>